// Graph.js
import React from 'react';
import { Box, useColorModeValue } from '@chakra-ui/react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Graph = () => {
  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        label: 'Users Gained',
        data: [33, 53, 85, 41, 44, 65, 95],
        fill: true,
        backgroundColor: useColorModeValue('#f0eded', '#0b0b0b'),
        borderColor: useColorModeValue('#383838', '#cccccc'),
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          color: useColorModeValue('#b5b5b5', '#616161'),
        },
      },
    },
  };

  return (
    <Box
      p={0}
      bg={useColorModeValue('#f0eded', '#0f0f0f')}
      borderRadius={15}
      boxShadow="none"
    >
      <Line data={data} options={options} height={'110%'} />
    </Box>
  );
};

export default Graph;
